<!--Choice Question-->
<workflow-multiple-choice
	*ngIf="question?.type === 'choice'"
	[question]="question"
	[justify]="justify"
	[isWizard]="isWizard"
	[finishedAndLocked]="finishedAndLocked"
	[isLocked]="isLocked"
	[isTableDisplay]="isTableDisplay"
	(valid)="setValid($event)">
</workflow-multiple-choice>

<!--Range Question-->
<workflow-range-question
	*ngIf="question?.type === 'range'"
	[question]="question"
	[justify]="justify"
	[isWizard]="isWizard"
	[finishedAndLocked]="finishedAndLocked"
	[isLocked]="isLocked"
	[validationLevel]="validationLevel"
	(valid)="setValid($event)"
></workflow-range-question>

<!--Text Question-->
<workflow-text-question
	*ngIf="question?.type === 'text'"
	[question]="question"
	[isWizard]="isWizard"
	[finishedAndLocked]="finishedAndLocked"
	[isLocked]="isLocked"
	[validationLevel]="validationLevel"
	(valid)="setValid($event)"
></workflow-text-question>

<workflow-text-area-question
	*ngIf="question?.type === 'textarea'"
	[question]="question"
	[isWizard]="isWizard"
	[finishedAndLocked]="finishedAndLocked"
	[isLocked]="isLocked"
	[validationLevel]="validationLevel"
	(valid)="setValid($event)">
</workflow-text-area-question>

<workflow-label-question
	*ngIf="question?.type === 'label'"
	[question]="question"
	[finishedAndLocked]="finishedAndLocked"
	(valid)="setValid($event)"
></workflow-label-question>

<workflow-date-question
	*ngIf="question?.type === 'date'"
	[question]="question"
	[finishedAndLocked]="finishedAndLocked"
	[isWizard]="isWizard"
	[isLocked]="isLocked"
	(valid)="setValid($event)">
</workflow-date-question>